import React, { Suspense } from "react";
import { AppContainer } from "react-hot-loader";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import Routes from "./Routes";
import i18n from "./i18n";
import LoadingWrapper from "../../components/wrapper/LoadingWrapper";

export default function doRender() {
  const router = (
    <Suspense fallback={<LoadingWrapper loading />}>
      <I18nextProvider i18n={i18n}>
        <AppContainer>
          <div className="semantic-ui">
            <BrowserRouter basename="/customer-portal">
              <Routes />
            </BrowserRouter>
          </div>
        </AppContainer>
      </I18nextProvider>
    </Suspense>
  );

  render(router, document.getElementById("root"));
}

doRender(Routes);

if (module.hot) {
  module.hot.accept("./Routes", () => {
    doRender(Routes);
  });
}
